// import { FieldTypes } from "../fields/types";
import { ActionType } from "../types/store-types";

export interface ICondition {
    _id?: string;
    value?: string;
    isValue?: boolean;
    condition?: string;
    target_id?: string;
}

export interface IAction {
    _id?: string;
    action?: string;
}
export interface IRule {
    name: string;
    enabled: boolean;
    conditions: ICondition[];
    actions: IAction[];
}

export interface IUpdateLogicRequestData {
    rules: IRule[];
}

export type LogicData = {
    rules: IRule[];
};

export type LogicDataSuccessType = {
    rules: IRule[];
};

export interface IUpdateLogicFailureData {
    error: boolean;
}

export type IInitLogicData = {
    rules: IRule[];
};

export interface IUpdateLogicSuccessData {
    data: LogicDataSuccessType;
}

export interface ILogicState {
    data: LogicDataSuccessType;
}

export enum LogicActionTypes {
    INIT_LOGIC = "LOGIC.INIT_LOGIC",
    UPDATE_LOGIC_REQUEST = "LOGIC.UPDATE_LOGIC_REQUEST",
    UPDATE_LOGIC_SUCCESS = "LOGIC.UPDATE_LOGIC_SUCCESS",
    UPDATE_LOGIC_FAILURE = "LOGIC.UPDATE_LOGIC_FAILURE",
}

/* - Actions Interfaces - */

export type InitLogicActionType = ActionType<LogicActionTypes.INIT_LOGIC, IInitLogicData>;

/* -- Update Logic Actions -- */

export type UpdateLogicRequestActionType = ActionType<LogicActionTypes.UPDATE_LOGIC_REQUEST, IUpdateLogicRequestData>;

export type UpdateLogicSuccessActionType = ActionType<LogicActionTypes.UPDATE_LOGIC_SUCCESS, IUpdateLogicSuccessData>;

export type UpdateLogicFailureActionType = ActionType<LogicActionTypes.UPDATE_LOGIC_FAILURE, IUpdateLogicFailureData>;
